import { useTranslation } from 'next-i18next';
import Link from 'next/link';
import Button from 'components/Button';
import { useCountUp } from 'utils/hooks/useCountUp';
import { AnimatedUnderline } from 'components/AnimatedUnderline';
import ParallaxImage from 'components/ParallaxImage';
import BannerImage from 'public/images/landing/hero-main.webp';
import BannerMobileImage from 'public/images/landing/hero-main-mobile.webp';

function HeroContentSection() {
  const { t } = useTranslation(['home', 'common']);
  const [countSeafarers, countSeafarersRef] = useCountUp({ start: 1, end: 36, duration: 500 });
  const [countCompanies, countCompaniesRef] = useCountUp({ start: 1, end: 45, duration: 500 });

  return (
    <div
      className="min-h-640 h-screen relative flex items-center bg-[#031B23] overflow-hidden"
    >
      <ParallaxImage
        src={BannerImage.src}
        blurDataURL={BannerImage.blurDataURL}
        alt="Onboard Crew App"
        verticalStart='-35%'
        verticalEnd='35%'
        className='right-0'
        isImageResponsive
        responsiveImageSources={[
          {
            media: '(max-width: 768px)',
            srcSet: BannerMobileImage.src,
            blurDataURL: BannerMobileImage.blurDataURL,
          },
        ]}
      />
      <div className='max-w-1280 w-full mx-auto mt-20 px-20 desktopSmall:px-40'>
        <div className="text-left w-full relative ipad:max-w-540">
          <h1 className="text-title2 mobile:text-subtitle1 desktopSmall:text-title1 text-white mb-16">
            <AnimatedUnderline delayMs={1200}>
              {t('HeroStreamline')}
            </AnimatedUnderline>
            <span className='font-medium'> {t('HeroYourCrew')} </span>
            <AnimatedUnderline delayMs={1700}>
              <span className='font-medium text-white relative z-10'>{t('HeroHiring')}</span>
            </AnimatedUnderline>
            <span className='font-medium'> {t('HeroManagement')} </span>
            <span className='font-medium'>— {t('HeroOnePlace')} </span>
          </h1>
          <p className="font-light text-regular3 text-grey mb-8 desktopSmall:text-xlarge3">
            {t('HeroSubtitle')}
          </p>
          <div className='mt-32 mb-56 flex flex-col ipad:flex-row gap-16'>
            <Link href='/companies' passHref>
              <Button
                outline
                size='large'
                className='rounded border-0 w-full ipad:inline-block'
                leftIcon='ri-user-add-line'
                text={t('RecruitSeafarer', { ns: 'common' })}
              />
            </Link>
            <Link href='/jobs' passHref>
              <Button
                outline
                size='large'
                color='#FFF'
                className='rounded bg-white/20 backdrop-blur-sm text-white border-none w-full ipad:inline-block'
                leftIcon='ri-ship-line'
                text={t('ApplyJobs', { ns: 'common' })}
                iconStyleCustom={{
                  color: '#CEFE62',
                }}
              />
            </Link>
          </div>
          <div className='flex gap-40 text-green-lime'>
            <div>
              <span ref={countSeafarersRef} className='text-title2 ipad:text-title1 font-medium'>{`${countSeafarers}K+`}</span>
              <p className='text-grey mt-8 font-light text-small3 ipad:text-regular3'>{t('HeroSeafarerLookingJobs')}</p>
            </div>
            <div>
              <span ref={countCompaniesRef} className='text-title2 ipad:text-title1 font-medium'>{`${countCompanies}+`}</span>
              <p className='text-grey mt-8 font-light text-small3 ipad:text-regular3'>{t('HeroShippingHiring')}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
};

export default HeroContentSection
